import React from 'react';

import {Box, VStack} from 'native-base';
import {findNodeHandle} from 'react-native';
import {
  FieldErrors,
  SubmitErrorHandler,
  SubmitHandler,
  useForm,
} from 'react-hook-form';

import {MapArea, TextArea} from '../../../../../../../components/inputs';
import {
  PrimaryButton,
  SecondaryButton,
} from '../../../../../../../components/buttons';
import useToast from '../../../../../../../hooks';
import {CoordinateType} from '../../../../../../../components/inputs/maparea/interfaces/coordinate-type';
import {ILogisticClient} from '../../../../../../../interfaces/dtos/salesman-client.interface';

interface FormProps {
  onSubmit?: (logisticInfo: ILogisticClient) => void;
}

export const LogisticForm = ({onSubmit: launchSubmitEvent}: FormProps) => {
  const {showInputsError} = useToast();

  const {
    control,
    handleSubmit,
    formState: {errors},
    reset,
  } = useForm({
    defaultValues: {
      businessHours: '',
      deliveryHours: '',
      transportTypes: '',
      deliveryConstrains: '',
      geoLocation: null as CoordinateType | null,
    } as ILogisticClient,
  });

  const handleClearForm = () => {
    reset();
  };

  const onSubmit: SubmitHandler<ILogisticClient> = async (
    data: ILogisticClient,
  ) => {
    if (launchSubmitEvent && data) {
      launchSubmitEvent(data);
    }
  };

  const onInvalid: SubmitErrorHandler<any> = async (
    fieldErrors: FieldErrors<any>,
  ) => {
    if (fieldErrors) {
      showInputsError();
    }
  };

  return (
    <>
      <VStack mt={2} marginX={4}>
        <TextArea
          control={control}
          name="businessHours"
          label="salesman-add-client-logistic-business-hours"
          error={errors.businessHours}
          numberOfLines={4}
          maxLength={250}
          rules={{
            required: 'form-is-required',
          }}
          onContentSizeChange={event => {
            var that: any = this;
            if (that && that.scrollRef && that.scrollRef.props) {
              that.scrollRef.props.scrollToFocusedInput(
                findNodeHandle(event.target),
              );
            }
          }}
        />
        <TextArea
          control={control}
          name="deliveryHours"
          label="salesman-add-client-logistic-delivery-hours"
          error={errors.deliveryHours}
          numberOfLines={4}
          maxLength={250}
          rules={{
            required: 'form-is-required',
          }}
          onContentSizeChange={event => {
            var that: any = this;
            if (that && that.scrollRef && that.scrollRef.props) {
              that.scrollRef.props.scrollToFocusedInput(
                findNodeHandle(event.target),
              );
            }
          }}
        />
        <TextArea
          control={control}
          name="transportTypes"
          label="salesman-add-client-logistic-transporte-types"
          error={errors.transportTypes}
          numberOfLines={4}
          maxLength={250}
          rules={{
            required: 'form-is-required',
          }}
          onContentSizeChange={event => {
            var that: any = this;
            if (that && that.scrollRef && that.scrollRef.props) {
              that.scrollRef.props.scrollToFocusedInput(
                findNodeHandle(event.target),
              );
            }
          }}
        />
        <TextArea
          control={control}
          name="deliveryConstrains"
          label="salesman-add-client-logistic-delivery-constrains"
          error={errors.deliveryConstrains}
          numberOfLines={4}
          maxLength={250}
          rules={{
            required: 'form-is-required',
          }}
          onContentSizeChange={event => {
            var that: any = this;
            if (that && that.scrollRef && that.scrollRef.props) {
              that.scrollRef.props.scrollToFocusedInput(
                findNodeHandle(event.target),
              );
            }
          }}
        />
        <MapArea
          control={control}
          name="geoLocation"
          label="salesman-add-client-logistic-geo-localization"
          error={errors.geoLocation}
          rules={{
            required: 'form-is-required',
          }}
        />
      </VStack>
      <Box mt={5} marginX={4}>
        <PrimaryButton
          label="salesman-customer-add-continue"
          onPress={handleSubmit(onSubmit, onInvalid)}
        />
      </Box>
      <Box mt={5} marginX={4}>
        <SecondaryButton
          label="salesman-button-reset"
          onPress={handleClearForm}
        />
      </Box>
    </>
  );
};
